<template>
  <v-container fluid class="pb-0 mb-0 mt-4">
    <v-row align="center" justify="center">
      <PersonalConference :conf="personal"
        @invite-member="inviteMember(personal)"
        @call-room="callPersonalConf($event)"/>
    </v-row>
    <v-row align="start" justify="start">
      <v-col cols="12">
        <v-row class="mt-1 pl-6 pr-6">
        <ConferenceCard
          :conf="conf" v-for="(conf, idx) in confCards" :key="idx"
          @invite-member="inviteMember(conf)"
          @call-room="callRoom(conf)"/>
        </v-row>
      </v-col>
    </v-row>
    <InviteMember :show="inviteShow" :conf="inviteConf"
      @cancel="inviteShow=false"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ConferenceCard from './conf_card'
import PersonalConference from './personal'
import InviteMember from './invite_member'

export default {
  name: 'conferences-panel',
  data () {
    return {
      inviteShow: true,
      inviteConf: null
    }
  },
  computed: {
    ...mapGetters({
      confCards: 'conferences/watched',
      personal: 'conferences/personal',
      memPane: 'conferences/memPaneShow'
    }),
    show: function () {
      return this.confCards?.length > 0
    }
  },
  components: { ConferenceCard, PersonalConference, InviteMember },
  methods: {
    ...mapActions({
      callConference: 'sipua/callConfBridge'
    }),
    callRoom: function (conf) {
      this.callConference({
        num: conf.exten,
        pin: conf.adminpin || conf.pin
      })
    },
    callPersonalConf: function (exten) {
      this.callConference({
        num: exten,
        pin: this.personal.adminpin || this.personal.pin
      })
    },
    inviteMember: function (conf) {
      this.inviteConf = conf
      this.inviteShow = true
    }
  }
}
</script>

<style scoped>
</style>
